import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BaseStatistic } from '@mtgame/core';

interface ParamType {
  id: string;
  title: string;
  percent?: boolean;
}

@Component({
  selector: 'mtg-volleyball-statistic-leaders',
  templateUrl: './volleyball-statistic-leaders.component.html',
  styleUrls: ['../styles/shared.scss', './volleyball-statistic-leaders.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VolleyballStatisticLeadersComponent implements OnChanges {
  @Input()
  seasonId: number;
  @Input()
  statistic: BaseStatistic[];
  filteredStatistic: BaseStatistic[];

  groups = [
    {
      id: 'attack',
      title: 'Атакующие действия',
      params: [
        {
          id: 'points',
          title: 'Очки'
        },
        {
          id: 'attackSpikes',
          title: 'Атаки'
        },
        {
          id: 'attackPercent',
          title: '% успешных атак'
        }
      ]
    },
    {
      id: 'defend',
      title: 'Защитные действия',
      params: [
        {
          id: 'stuffBlocks',
          title: 'Блоки',
        },
        {
          id: 'excellentReceives',
          title: 'Отл. приемы',
        },
        {
          id: 'excellentServeReceives',
          title: 'Отл. приемы подачи'
        }
      ]
    },
    {
      id: 'serves',
      title: 'Подачи',
      params: [
        {
          id: 'serveAces',
          title: 'Эйсы',
        },
        {
          id: 'acePercent',
          title: '% эйсов',
          percent: true
        },
      ]
    },
  ];

  selectedParams: {[key: string]: ParamType} = this.groups.reduce((acc, item) => ({
    ...acc,
    [item.id]: item.params[0]
  }), {});

  ngOnChanges(changes: SimpleChanges): void {
    this.filteredStatistic = this.statistic.filter(item => !item.newbie);
  }
}
